import Ilonacarousel1 from "./ilonacarousel (1).webp";
import Ilonacarousel2 from "./ilonacarousel (2).webp";
import Ilonacarousel3 from "./ilonacarousel (3).webp";
import Ilonacarousel4 from "./ilonacarousel (4).webp";

const ilonacarousel = [
  Ilonacarousel1,
  Ilonacarousel2,
  Ilonacarousel3,
  Ilonacarousel4,
];

export default ilonacarousel;
